var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section pb-3"},[_c('span',{staticClass:"body-2 text-uppercase grey--text text--darken-2"},[_vm._v(_vm._s(_vm.title))]),_c('v-divider',{staticClass:"ml-2"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }